


























































import Vue from "vue";

export default Vue.extend({
  name: "TextInput",
  props: {
    inputType: {
      type: String,
      required: false,
    },
    inputID: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: false,
    },
    inactive: {
      type: Boolean,
      required: false,
    },
    state: {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: false,
    },
    showClearButton: {
      type: Boolean,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    additionalInfo: {
      type: String,
      required: false,
    },
    errorMessage: {
      type: String,
      required: false,
    },
    changeFunction: {
      type: Function,
      required: true,
    },
  },
});
